import { log } from 'utils/logging';

import { RichError } from './RichError';

export function trackError(message: string | Error) {
  let metadata = {};

  if (message instanceof RichError) {
    metadata = message.metadata;
  }

  // @ts-expect-error ts-migrate(2339) FIXME: Property 'trackJs' does not exist on type 'Window ... Remove this comment to see the full error message
  if (window.trackJs && window.trackJs.track) {
    Object.keys(metadata).forEach((key) => {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'trackJs' does not exist on type 'Window ... Remove this comment to see the full error message
      window.trackJs.addMetadata(key, metadata[key]);
    });
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'trackJs' does not exist on type 'Window ... Remove this comment to see the full error message
    window.trackJs.track(message);
    Object.keys(metadata).forEach((key) => {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'trackJs' does not exist on type 'Window ... Remove this comment to see the full error message
      window.trackJs.removeMetadata(key);
    });
  } else {
    log.error(message, metadata);
  }
}
